<template xmlns:v-slot="http://www.w3.org/1999/html">
  <div class="kt-portlet kt-portlet--height-fluid mt-3">
    <div
      class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm flex-wrap"
    >
      <div class="kt-portlet__head-label mb-2">
        <span class="kt-portlet__head-icon">
          <SalesforceIcon height="40"></SalesforceIcon>
        </span>
        <h3 class="kt-portlet__head-title">Salesforce Shop Requests</h3>
      </div>
      <div class="kt-portlet__head-label mb-2 float-right">
        <v-btn
          small
          @click="exportAsCsv($auth.user().email)"
          :loading="loaders.exportRequest"
          color="primaryMain"
          dark
          class="primaryMainText--text mb-2 mr-2"
          style="color: white !important"
        >
          Export as CSV
        </v-btn>
      </div>
    </div>
    <div class="kt-portlet__body">
      <div class="px-3">
        <div class="row no-gutters pt-3">
          <div class="col-xl-4">
            <v-select
              class="mt-0 pt-0"
              :loading="loaders.dataTable"
              :disabled="loaders.dataTable"
              @change="fetchData"
              v-model="pagination.status"
              multiple
              prepend-inner-icon="fas fa-filter"
              :items="statusFilters"
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleAllStatus">
                  <v-list-item-content>
                    <v-list-item-title>All</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </div>
          <v-spacer />
          <div class="col-xl-4">
            <v-text-field
              class="mt-0 pt-0"
              v-model.trim="pagination.search"
              @input="debouncedFetchData"
              append-icon="fal fa-search"
              label="Search Dealer"
              single-line
              hide-details
            />
          </div>
        </div>
      </div>
      <div class="px-3">
        <div class="row no-gutters pt-3">
          <v-spacer />
          <div class="col-xl-4">
            <v-menu
              ref="rangeMenu"
              v-model="rangeMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="pt-0"
                  v-model="dateRangeText"
                  :value="dateRange"
                  label="Filter Date Range"
                  prepend-icon="fal fa-calendar"
                  v-on="on"
                  clearable
                  @click:clear="clearDateRangeSelection"
                  clear-icon="fal fa-times-circle"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dates"
                range
                no-title
                color="blue"
                value="mm-dd-YYYY"
              >
                <v-spacer />
                <v-btn text color="info" @click="cancelRangeSelection"
                  >Cancel</v-btn
                >
                <v-btn text color="info" @click="confirmRangeSelection"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </div>
      <v-data-table
        :headers="headers"
        :items="salesforceRequests"
        :search="pagination.search"
        :sort-by="pagination.sortBy"
        :sort-desc="sortDesc"
        class="elevation-1"
        :items-per-page="pagination.per_page"
        :server-items-length="pagination.total"
        @update:page="changePage"
        :disable-pagination="loaders.dataTable"
        :loading="loaders.dataTable"
        @update:sort-by="sortByUpdate"
        @update:sort-desc="sortDescUpdate"
      >
        <template v-slot:item.requested_at="{ item }">
          <span>{{ item.requested_at }}</span>
        </template>
        <template v-slot:item.action="{ item }">
          <div>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs, value }">
                <v-btn v-bind="attrs" v-on="on" icon>
                  <div style="display: flex; align-items: center">
                    <v-icon> fas fa-ellipsis-h</v-icon>
                  </div>
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn @click="openUpdateDialogState(item)" text small>
                      Update Request
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-btn
                    @click="cancelShopRequest(item)"
                    text
                    small
                    :loading="loaders.cancelShopRequest"
                  >
                    Cancel Request
                  </v-btn>
                </v-list-item>
                <v-list-item v-if="isEmpty(item.mystery_shop_class)">
                  <router-link
                    :to="{
                      name: 'Internet Shop Form',
                      query: { requestId: item.request_id },
                    }"
                    target="_blank"
                  >
                    <span
                      class="v-btn v-btn--flat v-btn--text theme--light v-size--small"
                      >New Internet Shop
                    </span>
                  </router-link>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="resetTable">Reset</v-btn>
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="updateDialogState" width="400px">
      <v-card>
        <v-toolbar dark color="secondary">
          <v-card-title>
            <span class="headline">
              Update Salesforce Shop Request Status
            </span>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="closeUpdateDialogState"
            icon
            :loading="loaders.updateDialog"
            >fas fa-times
          </v-btn>
        </v-toolbar>
        <v-card-text class="mt-4">
          <label>Status</label>
          <v-select
            solo
            v-model="form.status"
            :items="statuses"
            item-text="friendly_name"
            item-value="name"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="info"
            dark
            style="color: white !important"
            :loading="loaders.updateDialog"
            @click="updateSalesForceRequestStatus"
            >Save</v-btn
          >
          <v-btn
            color="orange darken-1"
            dark
            @click="closeUpdateDialogState"
            :loading="loaders.updateDialog"
            style="color: white !important"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="exportDialog" width="500" persistent>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Send as email
        </v-card-title>
        <v-card-text>
          <p class="mt-2">Enter email addresses, separated by commas.</p>
          <v-text-field
            v-model="emails"
            v-validate="'required'"
            name="emails"
          ></v-text-field>
          <p
            class="kt-font-danger validate-error"
            v-show="errors.has('emails')"
            v-html="errors.first('emails')"
          ></p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="exportDialog = false"
            :disabled="loaders.exportRequest"
          >
            Cancel
          </v-btn>
          <v-btn
            color="info"
            @click="exportAsCsv"
            :loading="loaders.exportRequest"
          >
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  isEmpty as _isEmpty,
  some as _some,
  chain as _chain,
  includes as _includes,
  forEach as _forEach,
  replace as _replace,
  isArray as _isArray,
} from 'lodash-es';
import SalesforceIcon from '@/components/salesforce/icons/SalesforceIcon.vue';
import { debounce } from 'lodash';

export default {
  name: 'SalesforceShopRequests',
  components: { SalesforceIcon },
  data() {
    return {
      emails: '',
      isEmpty: _isEmpty,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['request_date'],
        sortDesc: [true],
      },
      loaders: {
        dataTable: true,
        updateDialog: false,
        cancelShopRequest: false,
        exportRequest: false,
      },
      filters: '',
      updateDialogState: false,
      headers: [
        {
          text: 'Request ID',
          align: 'left',
          sortable: true,
          value: 'request_id',
        },
        {
          text: 'Account Manager',
          value: 'account_manager',
          sortable: true,
        },
        {
          text: 'Account Manager Email',
          value: 'account_manager_email',
          sortable: true,
        },
        {
          text: 'Dealer',
          value: 'dealer',
          sortable: true,
        },
        {
          text: 'Status',
          value: 'friendly_status',
          sortable: true,
        },
        {
          text: 'Date Requested',
          value: 'requested_at',
          sortable: true,
        },
      ],
      pagination: {
        total: -1,
        per_page: 10,
        current_page: 1,
        search: '',
        sortBy: 'request_date',
        sortDesc: true,
        status: [],
        dealers: [],
        dateFrom: '',
        dateTo: '',
      },
      salesforceRequests: [],
      form: {
        id: null,
        accountManager: null,
        dealer: null,
        secretShopType: null,
        notes: null,
        status: null,
        requestId: null,
      },
      rangeMenu: false,
      dates: [],
      dealers: [],
      exportDialog: false,
      statusFilters: [],
      currentPage: 1,
    };
  },
  computed: {
    statuses() {
      return this.$store.state.secretShopStatuses.statuses;
    },
    dateRangeText() {
      if (!this.dates) {
        return '';
      }
      return this.dates.join(' ~ ');
    },
    isAdmin() {
      return _some(this.$auth.user().roles, { name: 'super-administrator' });
    },
    isSecretShopper() {
      return _some(this.$auth.user().roles, { name: 'secret-shopper' });
    },
  },
  watch: {
    dates(newDates) {
      this.pagination.dateFrom = newDates ? newDates[0] : null;
      this.pagination.dateTo = newDates[1] ? newDates[1] : newDates[0];
      this.currentPage = 1;
      this.fetchData();
    },
  },
  created() {
    if (this.isSecretShopper || this.isAdmin) {
      this.headers.push({
        text: 'Actions',
        value: 'action',
        align: 'center',
        width: 200,
        sortable: false,
      });
    }
    this.initialize();
  },
  methods: {
    sortByUpdate(sortBy) {
      this.pagination.sortBy = sortBy;
      this.currentPage = 1;
      this.fetchData();
    },
    sortDescUpdate(sortDesc) {
      this.pagination.sortDesc = sortDesc;
      this.currentPage = 1;
      this.fetchData();
    },
    async initialize() {
      this.statusFilters = [
        { text: 'New Request', value: 'new-request' },
        { text: 'In Progress', value: 'in-progress' },
        { text: 'Completed', value: 'completed' },
        { text: 'Cancelled', value: 'cancelled' },
        { text: 'Dealer Not Found', value: 'dealer-not-found' },
      ];

      if (
        (window.location.origin.toString().includes('app.webinarinc.com') &&
          this.isAdmin) ||
        window.location.origin.toString().includes('localhost') ||
        window.location.origin.toString().includes('127.0.0.1')
      ) {
        this.statusFilters.push({
          text: 'Overdue',
          value: 'overdue',
        });
      }

      this.pagination.status = [
        'new-request',
        'in-progress',
        'completed',
        'cancelled',
        'dealer-not-found',
      ];
      await this.fetchDealers();
      this.pagination.dealers = this.dealers;
      this.fetchData();
    },
    changePage(page) {
      this.currentPage = page;
      this.fetchData();
    },
    // eslint-disable-next-line func-names
    debouncedFetchData: debounce(function () {
      this.fetchData();
    }, 1000),
    fetchData() {
      this.pagination.sortBy =
        this.pagination.sortBy !== undefined
          ? this.pagination.sortBy
          : 'requested_at';
      if (_isArray(this.pagination.sortDesc)) {
        this.pagination.sortDesc = this.pagination.sortDesc[0];
      } else {
        this.pagination.sortDesc = true;
      }

      this.loaders.dataTable = true;

      this.axios
        .get('salesforce-requests', {
          params: {
            keyword: this.pagination.search,
            sort_by: this.pagination.sortBy,
            sort_desc: this.pagination.sortDesc,
            items_per_page: this.pagination.per_page,
            page: this.currentPage,
            status: this.pagination.status,
            dealers: this.pagination.dealers,
            dateFrom: this.pagination.dateFrom,
            dateTo: this.pagination.dateTo,
          },
        })
        .then(({ data }) => {
          const { meta, items } = data;
          this.salesforceRequests = items;

          this.pagination.total = meta.total_items;

          this.loaders.dataTable = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    resetTable() {
      this.pagination.search = '';
      this.pagination.current_page = 1;
      this.total_items = 5;
      this.currentPage = 1;
      this.fetchData();
    },
    openUpdateDialogState(item) {
      this.form.id = item.id;
      this.form.status = item.status;
      this.form.requestId = item.request_id;
      this.form.accountManager = item.account_manager;
      this.form.dealer = item.dealer;
      this.form.notes = item.notes;
      this.form.secretShopType = item.secret_shop_type;
      this.updateDialogState = true;
    },
    closeUpdateDialogState() {
      this.form.id = null;
      this.form.status = null;
      this.form.requestId = null;
      this.form.accountManager = null;
      this.form.dealer = null;
      this.form.notes = null;
      this.form.secretShopType = null;
      this.updateDialogState = false;
    },
    updateSalesForceRequestStatus() {
      this.loaders.updateDialog = true;

      this.axios
        .patch(`salesforce-requests/${this.form.id}`, {
          request_id: this.form.requestId,
          status: this.form.status,
          notes: this.form.notes,
          account_manager: this.form.accountManager,
          dealer: this.form.dealer,
          secret_shop_type: this.form.secretShopType,
        })
        .then(({ data }) => {
          this.loaders.updateDialog = false;
          this.$notify('success', data.message);
          this.closeUpdateDialogState();
          this.fetchData();
        });
    },
    cancelShopRequest(item) {
      this.loaders.cancelShopRequest = true;
      this.axios
        .delete(`salesforce-requests/${item.id}`, {
          data: {
            request_id: item.request_id,
          },
        })
        .then(({ data }) => {
          this.loaders.cancelShopRequest = false;
          this.$notify('success', data.message);
          this.fetchData();
        });
    },
    toggleAllStatus() {
      this.pagination.status = [
        'new-request',
        'in-progress',
        'completed',
        'cancelled',
        'dealer-not-found',
        'overdue',
      ];
      this.currentPage = 1;
      this.fetchData();
    },
    toggleAllDealers() {
      this.pagination.dealers = this.dealers;
      this.currentPage = 1;
      this.fetchData();
    },
    confirmRangeSelection() {
      this.pagination.dateFrom = this.dates ? this.dates[0] : '';
      this.pagination.dateTo = this.dates
        ? this.dates[1]
        : this.pagination.dateFrom;
      this.$refs.rangeMenu.save(this.dates);
      this.rangeMenu = false;
    },
    cancelRangeSelection() {
      this.dates = [];
      this.$refs.rangeMenu.save(null);
      this.rangeMenu = false;
    },
    clearDateRangeSelection() {
      this.dates = [];
      this.pagination.dateFrom = '';
      this.pagination.dateTo = '';
      this.currentPage = 1;
      this.fetchData();
    },
    fetchDealers() {
      return new Promise((resolve, reject) => {
        this.axios
          .get('salesforce-dealers')
          .then(({ data }) => {
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    exportAsCsv() {
      if (_isEmpty(this.emails)) {
        this.emails = this.$auth.user().email;
      }

      const emailsArray = this.emails.split(',');

      this.loaders.exportRequest = true;
      this.axios
        .post('v3/export/salesforce-requests', {
          keyword: this.pagination.search,
          sort_by: this.pagination.sortBy,
          sort_desc: this.pagination.sortDesc,
          status: this.pagination.status,
          dealers: this.pagination.dealers,
          dateFrom: this.pagination.dateFrom,
          dateTo: this.pagination.dateTo,
          emails: emailsArray,
        })
        .then(({ data }) => {
          this.emails = null;

          this.$notify('success', data.message);

          this.$nextTick(() => {
            this.exportDialog = false;
            this.loaders.exportRequest = false;
          });
        })
        .catch((errors) => {
          const validations = errors.response.data.errors;

          const validationErrors = _chain(validations)
            .filter((message, field) => _includes(field, 'emails'))
            .flatten()
            .value();

          let message = '';

          _forEach(validationErrors, (error, index) => {
            message = `${
              message + _replace(error, `emails.${index}`, emailsArray[index])
            }<br>`;
          });

          console.log(message);

          this.errors.add({
            field: 'emails',
            msg: message,
          });

          this.$nextTick(() => {
            this.loaders.exportRequest = false;
          });
        });
    },
  },
};
</script>
<style lang="stylus" scoped>
.v-icon.v-icon {
    font-size: 16px;
}
</style>
